import { apiCall } from '../helpers/apiHelpers';
import { ApiResult } from '../types/api/common';
import { PrintDocumentResponse } from '../types/api/responses';

interface MortgageDocumentParams {
  sessionId: string;
  agreementId: string;
}

/**
 * Полис ипотеки: отдельный роут со сверкой владельца по email сессии (DEV-514),
 * а не общий /client/contract/print. Формат ответа тот же.
 */
export const mortgageDocumentService = ({ sessionId, agreementId }: MortgageDocumentParams): Promise<ApiResult<PrintDocumentResponse>> =>
  apiCall<PrintDocumentResponse>({
    method: 'GET',
    url: `/client/mortgage/document?clientSessionId=${sessionId}&agreementId=${agreementId}`,
  })();
